import React from 'react';
import { DatePickerInput, DatePickerInputProps, styled } from '@withjoy/joykit';
import { useInputErrorStyles } from '@shared/createEvent/hooks/useInputErrorStyles';
import { OVERRIDE_HOVER_STYLES, inputStyles, rootStyles } from '@shared/createEvent/formElements/formElements.styles';
import { Calendar } from '@withjoy/joykit/icons';

const StyledEventDatePickerInputV2 = styled(DatePickerInput)`
  ${OVERRIDE_HOVER_STYLES};
`;

const EventDatePickerInputV2 = React.forwardRef<HTMLInputElement, DatePickerInputProps>(({ overrides, ...props }) => {
  const rootInvalidStyles = useInputErrorStyles();
  const overridesInvalid = {
    ...overrides,
    Input: {
      ...overrides?.Input,
      Root: {
        props: rootInvalidStyles,
      },
    },
  };
  return (
    <StyledEventDatePickerInputV2
      {...props}
      overrides={props.isInvalid ? overridesInvalid : overrides}
      endElement={null}
      mask={null}
      placement="top"
      minDate={new Date()}
      dateFormat="MM/dd/yyyy"
      placeholder="MM/DD/YYYY"
      startElement={
        <Calendar
          size={24}
          color="mono14"
          marginLeft={1}
        />
      }
    />
  );
});

EventDatePickerInputV2.defaultProps = {
  overrides: {
    Input: {
      Root: {
        props: rootStyles,
      },
      Input: {
        props: { ...inputStyles, paddingLeft: 52 },
      },
    },
  },
};

export { EventDatePickerInputV2 };
